<template>
  <!-- 深蓝色模板 -->

  <div class="content">
    <img
      class="content__bg"
      :src="
        competitionStyle.backgroundImgType === 1
          ? competitionStyle.backgroundImgUrl
          : defaultBackgroundUrl
      "
      alt=""
    />
    <div class="arrange">
      <div class="title">
        <img src="../../../assets/saishianpai-title-icon.png" alt="" />
        <p>{{ competition.planTitle || "赛事安排" }}</p>
      </div>
      <div class="detail">
        <div
          class="img"
          @click="scrollLeft('.msg')"
          v-if="competitionPlanList.length > 5"
        >
          <img src="../../../assets/saishianpai-left-icon.png" alt="" />
        </div>
        <div class="msg">
          <div class="item" v-for="item in competitionPlanList" :key="item.id">
            <img :src="getImageURL(item.iconType, 'saishianpai')" alt="" />
            <p>{{ item.title }}</p>
            <div class="line">
              <div class="left-line"></div>
              <div class="dot"></div>
              <div class="right-line"></div>
            </div>
            <div class="ql-editor" v-html="item.planTime"></div>
          </div>
        </div>
        <div
          class="img"
          @click="scrollRight('.msg')"
          v-if="competitionPlanList.length > 5"
        >
          <img src="../../../assets/saishianpai-right-icon.png" alt="" />
        </div>
      </div>
    </div>
    <div class="prefecture">
      <div class="title">
        <img src="../../../assets/saishianpai-title-icon.png" alt="" />
        <p>{{ competition.preparationZoneTitle || "备赛专区" }}</p>
      </div>
      <div class="prefecture-msg">
        <div class="prefecture-top">
          <div class="entrance">
            <div class="entrance-title">
              {{ competition.fastEnterTitle || "快速入口" }}
            </div>
            <div class="entrance-list">
              <div
                class="entrance-item"
                v-for="(item, index) in competitionFastEnterList"
                :key="index"
              >
                <div
                  class="entrance-item-child"
                  v-for="item1 in item"
                  :key="item1.id"
                  @click="$emit('on-entrance', item1)"
                >
                  <div class="entrance-item-child-left">
                    <img :src="getImageURL(item1.iconType, 'rukou')" alt="" />
                    <p
                      class="ql-editor"
                      v-html="item1.title"
                    ></p>
                  </div>
                  <img
                    class="right-icon"
                    src="../../../assets/rukou-right.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div class="entrance-btn" v-if="isCompetitionFastEnter">
              <img
                class="entrance-btn-left"
                @click="scrollLeft('.entrance-list')"
                src="../../../assets/left-icon.png"
                alt=""
              />
              <img
                @click="scrollRight('.entrance-list')"
                src="../../../assets/right-icon.png"
                alt=""
              />
            </div>
          </div>
          <div class="announcement">
            <div class="announcement-title">
              {{ competition.newsTitle || "赛事公告" }}
            </div>
            <div class="announcement-list">
              <div
                class="announcement-item"
                v-for="(item, index) in competitionNewsList"
                :key="index"
              >
                <div
                  class="announcement-item-child"
                  @click="changeAnnouncement(item1)"
                  v-for="item1 in item"
                  :key="item1.id"
                >
                  <p
                    class="name"
                    :style="{
                      color:
                        item1.isImportant == 1
                          ? competitionStyle.importantNewsColor
                          : '#fff',
                    }"
                  >
                    {{ item1.title }}
                  </p>
                  <p class="time">{{ item1.publishDate }}</p>
                </div>
              </div>
            </div>
            <div class="announcement-btn" v-if="iCompetitionNews">
              <img
                class="announcement-btn-left"
                @click="scrollLeft('.announcement-list')"
                src="../../../assets/left-icon.png"
                alt=""
              />
              <img
                @click="scrollRight('.announcement-list')"
                src="../../../assets/right-icon.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="prefecture-bottom">
          <div class="prefecture-bottom-title">
            {{ competition.resourceTitle || "资源下载" }}
          </div>
          <div class="list">
            <div
              class="item"
              v-for="item in competitionResourceList"
              :key="item.id"
            >
              <img :src="item.imgUrl" alt="" />
              <div class="msg">
                <p class="name">{{ item.title }}</p>
                <p class="item-detail">{{ item.subtitle }}</p>
                <div class="download-btn">
                  <p @click="download(item.fileUrl)">下载</p>
                </div>
              </div>
            </div>
          </div>
          <div class="btns" v-if="competitionResourceList.length > 3">
            <img
              @click="scrollLeft('.list')"
              src="../../../assets/left-icon.png"
              alt=""
            />
            <img
              @click="scrollRight('.list')"
              src="../../../assets/right-icon.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div class="introduce">
      <div class="title">
        <img src="../../../assets/saishianpai-title-icon.png" alt="" />
        <p>{{ competition.introTitle || "赛事介绍" }}</p>
      </div>
      <div class="introduce-content">
        <div v-html="competitionIntro.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/style/quillEditor.css";
import defaultBackgroundUrl from "../../../assets/detail-bg.png";

export default {
  name: "DeepBlueTemplate",
  props: {
    competition: {
      type: Object,
      default: () => ({}),
    },
    competitionFastEnterList: {
      type: Array,
      default: () => [],
    },
    competitionNewsList: {
      type: Array,
      default: () => [],
    },
    competitionResourceList: {
      type: Array,
      default: () => [],
    },
    competitionPlanList: {
      type: Array,
      default: () => [],
    },
    isCompetitionFastEnter: { type: Boolean, default: false }, //快速入口分页按钮
    iCompetitionNews: { type: Boolean, default: false }, //赛事公告分页按钮
    isCompetitionResource: { type: Boolean, default: false }, //资源下载分页按钮
    fullscreenLoading: { type: Boolean, default: false }, //全局加载状态
    competitionIntro: {
      type: Object,
      default: () => ({}),
    },
    competitionStyle: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return { defaultBackgroundUrl };
  },
  methods: {
    download(fileUrl) {
      window.location.href = fileUrl;
    },
    //{{ competition.newsTitle || "赛事公告" }}
    changeAnnouncement(item) {
      window.open(item.url);
    },
    //动态图标
    getImageURL(iconType, name) {
      // 根据图标类型拼接图片路径
      return require(`@/assets/${name}-icon-${iconType}.png`);
    },

    scrollLeft(name) {
      const dataBar = document.querySelector(name);
      dataBar.scrollTo({
        left: dataBar.scrollLeft - dataBar.clientWidth,
        behavior: "smooth",
      });
    },

    scrollRight(name) {
      const dataBar = document.querySelector(name);
      dataBar.scrollTo({
        left: dataBar.scrollLeft + dataBar.clientWidth,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.entrance-list {
  display: flex;
  overflow-x: auto;
}
.entrance-list::-webkit-scrollbar {
  display: none !important;
}
.entrance-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
.entrance-btn img {
  width: 10px;
  height: 18px;
  cursor: pointer;
}
.entrance-btn-left {
  margin-right: 80px;
}
.entrance-item {
  display: flex;
  flex-wrap: wrap;
  flex-shrink: 0;
  width: 100%;
  cursor: pointer;
  align-content: flex-start;
}
.entrance-item-child {
  width: 217px;
  height: 50px;
  background: #e5eeff;
  border-radius: 25px;
  border: 1px solid #2f77ff;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: 29px;
}
.entrance-item-child-left {
  display: flex;
  align-items: center;
}
.entrance-item-child p {
  font-weight: 600;
  line-height: 20px;
}
.entrance-item-child .right-icon {
  width: 7px;
  height: 13px;
  margin-right: 15px;
}
.entrance-item-child img {
  width: 68px;
  height: 50px;
}
.entrance-item {
  padding: 0 30px 0 0;
}
.entrance {
  padding: 20px 0;
}

.entrance-title {
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
  line-height: 28px;
  padding: 0 30px;
}
.announcement-list {
  display: flex;
  align-items: flex-start;
  overflow-x: auto;
}
.announcement-list::-webkit-scrollbar {
  display: none !important;
}
.announcement-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 9px;
}
.announcement-btn img {
  width: 10px;
  height: 18px;
  cursor: pointer;
}
.announcement-btn-left {
  margin-right: 80px;
}
.announcement {
  padding: 20px 0;
}
.announcement .announcement-title {
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
  line-height: 28px;
  margin-bottom: 7px;
  padding: 0 30px;
}
.announcement-item-child {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 0;
  cursor: pointer;
  border-bottom: 1px solid #e5e5e5;
}
.announcement-item-child:last-child {
  border-bottom: none;
}
.announcement-item-child .name {
  font-size: 14px;
  line-height: 16px;
  width: 360px;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.announcement-item-child .time {
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  line-height: 16px;
  width: 85px;
  margin-top: 0;
  margin-left: 20px;
}
.announcement-item {
  padding: 0 30px;
}
.emphasis {
  font-weight: 600;
  color: #046bde;
}
.unemphasis {
  font-weight: 400;
  color: #fff;
}
.btns {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
}
.btns img {
  width: 10px;
  height: 18px;
  cursor: pointer;
}
.btns img:first-child {
  margin-right: 80px;
}
.download-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 16px;
  font-weight: 400;
  color: #ffffff;
  line-height: 16px;
  text-align: right;
  cursor: pointer;
  margin-top: 5px;
}
.download-btn p {
  width: 56px;
  height: 25px;
  background: #046bde;
  border-radius: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
.prefecture-bottom .list .item .item-detail {
  font-size: 16px;
  font-weight: 400;
  color: #909399;
  line-height: 22px;
  margin-top: 10px;
  height: 40px;
  display: -webkit-box; /* Safari */
  -webkit-line-clamp: 2; /* Safari and Chrome */
  -webkit-box-orient: vertical; /* Safari and Chrome */
  overflow: hidden;
}
.prefecture-bottom .list .item .name {
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  line-height: 16px;
}
.prefecture-bottom .list .item img {
  width: 100px;
  height: 100px;
}
.prefecture-bottom .list .item .msg {
  margin-left: 20px;
  width: 100%;
}
.prefecture-bottom .list .item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 320px;
  flex-shrink: 0;
  margin-right: 30px;
}
.prefecture-bottom .list {
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 20px;
  overflow-x: scroll;
}
.prefecture-bottom .list::-webkit-scrollbar {
  display: none !important;
}
.prefecture-bottom {
  padding: 20px 0 30px 30px;
}
.prefecture-bottom-title {
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
  line-height: 28px;
}
.prefecture-msg {
  padding: 0 50px;
}
.prefecture-bottom {
  width: 100%;
  height: 246px;
  background: #0a2b51;
  border-radius: 20px;
  border: 1px solid #046bde;
  margin-top: 30px;
}
.prefecture-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 74px;
}

.prefecture-top .announcement,
.prefecture-top .entrance {
  width: 524px;
  height: 316px;
  background: #0a2b51;
  border-radius: 20px;
  border: 1px solid #046bde;
}
.introduce-content::-webkit-scrollbar {
  display: none !important;
}
.introduce-content {
  width: 1180px;
  /* height: 352px; */
  /* overflow-y: auto; */
  font-size: 16px;
  font-weight: 400;
  color: #ffffff;
  line-height: 32px;
  margin: 0 auto;
  /* margin-top: 74px; */
  padding: 0 50px 30px;
  /* margin: 0 1px; */
  margin-left: 1px;
  border-left: 4px solid #235891;
  border-right: 4px solid #235891;
  border-bottom: 4px solid #235891;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  white-space: pre-wrap;
}
.introduce-content p {
  margin-bottom: 20px;
  text-align: justify;
}
.prefecture {
  z-index: 1;
  width: 1178px;
  height: 812px;

  margin: 0 auto;
  background: url("../../../assets/beisaizhuanqu-bg.png");
  background-position: center center;
  margin-top: 48px;
}
.introduce {
  z-index: 1;
  width: 1178px;
  /* height: 572px; */
  margin: 0 auto;
  /* background: url("../../../assets/dasaijieshao-new-bg.png") no-repeat;
  background-position: center center; */
  margin-top: 48px;
  /* margin-right: 1px; */
}
.introduce .title {
  width: 1184px;
  height: 170px;
  background: url("../../../assets/dasaijieshao-new-bg.png") no-repeat;
  background-position: top center;
  margin: 0;
  padding: 0 0 0 52px;
}
.msg::-webkit-scrollbar {
  display: none !important;
}

.line {
  display: flex;
  align-items: center;
  margin-top: 25px;
}
.left-line {
  width: 88px;
  height: 4px;
  background: #2f77ff;
}
.right-line {
  width: 89px;
  height: 4px;
  background: #2f77ff;
}
.dot {
  width: 20px;
  height: 20px;
  background: #2f77ff;
  border-radius: 50%;
}
.detail {
  display: flex;
  padding: 0 50px;
  margin-top: 62px;
}
.detail .img {
  padding-top: 42px;
}
.detail img {
  width: 52px;
  height: 52px;
  cursor: pointer;
}
.detail .msg {
  flex: 1;
  display: flex;
  align-items: flex-start;
  overflow-x: auto;
  justify-content: center;
}
.msg .item {
  width: 196px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 18px;
  font-weight: 400;
  color: #ffffff;
  line-height: 25px;
  cursor: pointer;
}
.item img {
  width: 90px;
  height: 94px;
  margin-bottom: 8px;
}
.container {
  background: #171f30;
}
.content {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #171f30;
  padding-bottom: 150px;

  &__bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 1000px;
    object-fit: cover;
  }
}
.arrange {
  width: 1178px;
  height: 430px;
  margin: 0 auto;
  background: url("../../../assets/saishianpai-bg.png");
  background-position: center center;
  margin-top: -70px;
  z-index: 1;
}
.title {
  display: flex;
  align-items: center;
  margin: 52px 0 0 52px;
}
.title img {
  width: 42px;
  height: 39px;
}
.title p {
  font-size: 40px;
  font-weight: 600;
  color: #ffffff;
  line-height: 40px;
  margin-left: 24px;
}
</style>
